'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.overflowsY = exports.overflowsX = undefined;

var _BrowserTest = require('./BrowserTest');

var overflowsX = exports.overflowsX = function overflowsX(innerEl) {
  var outerEl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : innerEl;

  var tolerance = (0, _BrowserTest.isIE11)() ? 1 : 0; // IE rounding bug workaround; see HubSpot/UIComponents#1711
  var contentWidth = innerEl.scrollWidth;
  var containerWidth = outerEl.clientWidth;
  return contentWidth > containerWidth + tolerance;
};

var overflowsY = exports.overflowsY = function overflowsY(innerEl) {
  var outerEl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : innerEl;

  var tolerance = (0, _BrowserTest.isIE11)() ? 1 : 0; // IE rounding bug workaround; see HubSpot/UIComponents#1711
  var contentHeight = innerEl.scrollHeight;
  var containerHeight = outerEl.clientHeight;
  return contentHeight > containerHeight + tolerance;
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/utils/Overflows.js
// module id = 263
// module chunks = 0